import HTTP from "../http";
import paramsHelper from "../helpers/params";

import Jsona from "jsona";
const dataFormatter = new Jsona();

export default {
  async getByProfessional(payload) {
    let { professionalID, page, next } = payload;
    let url = "";

    if (next) {
      url = next;
    } else {
      let filters = [
        {
          name: "professional",
          value: professionalID
        }
      ];
      let pagination = { number: page, size: 10 };
      let paramsData = { filters, pagination };

      let params = paramsHelper.buildParams(paramsData);

      url = `/feedbacks${params}`;
    }

    try {
      let res = await HTTP.normal.get(url);

      return {
        data: dataFormatter.deserialize(res.data),
        next: res.data.links.next
      };
    } catch (e) {
      throw "Ocorreu um erro ao buscar avaliações do profissional";
    }
  }
};



// WEBPACK FOOTER //
// ./src/api/modules/feedbacks.js